import * as Sentry from "@sentry/browser";
import { FirebaseAdapter } from "./adapters/firebase/firebase.adapter.js";
function initializer(config) {
  let firebaseConfig;
  if (typeof window !== "undefined" && config.sentryConfig) {
    Sentry.init({
      beforeSend: config.sentryConfig.beforeSend,
      ...config.sentryConfig,
      dsn: config.sentryConfig.url,
      environment: config.environment
    });
  }
  if (config.authConfig && config.appConfig) {
    firebaseConfig = FirebaseAdapter.init(config.appConfig, config.authConfig);
  }
  return {
    ...firebaseConfig,
    Sentry
  };
}
export {
  initializer
};
//# sourceMappingURL=initializer.js.map
